import Vue from 'vue'
import Router from 'vue-router'
import Form from '@/components/Form'
import ThankYou from '@/components/ThankYou'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Form',
      component: Form
    },
    {
      path: '/hvala',
      name: 'ThankYou',
      component: ThankYou
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js